import { useEffect, useMemo, useRef, useState } from 'react'

import { Loader } from 'core-components/library/loader'
import { IFromLibrarySettings, IWidget } from 'core-components/sitebuilder/models/IWidget'
import { prepareProps } from 'core-components/sitebuilder/propertygenerator'

import { CommonProperties } from '../../settings'

import { AccordionFilterEditor } from './editors/AccordionFilterEditor'
import { TableEditor } from './editors/TableEditor'
import { getProperty } from './helpers/getProperty'

interface IWidgetLibraryContent {
  widget: IWidget
  convertProps?: () => Promise<unknown>
}

export const LibraryContent = ({ widget, convertProps }: IWidgetLibraryContent) => {
  const [props, setProps] = useState<any>()
  const settingsRef = useRef<IFromLibrarySettings['properties']>([])
  const settings = widget.settings as IFromLibrarySettings
  const eventBusData = useMemo(() => {
    return getProperty(settings.properties, CommonProperties.EventBusChannel)
  }, [settings.properties])

  useEffect(() => {
    const prop = (widget.settings as IFromLibrarySettings)?.properties
    if (prop !== settingsRef.current) {
      settingsRef.current = prop
      const propsConverter = convertProps ? convertProps() : prepareProps(settings.properties || [])
      propsConverter.then((newProps) => {
        setProps(newProps)
      })
    }
  }, [convertProps, settings.properties, widget])

  if (!props) {
    return <Loader />
  }

  if (settings.type === 'Table') {
    return <TableEditor props={props} eventBusData={eventBusData} />
  }

  if (settings.type === 'AccordionFilter') {
    return <AccordionFilterEditor props={props} eventBusData={eventBusData} />
  }

  return <div>Wrong library widget type</div>
}
